import { useEffect, useState } from 'react'
import {
  type DeviceMode,
  getStoredDeviceMode,
  resolveIsDesktop,
  setStoredDeviceMode,
} from './deviceMode'

export interface UseDeviceModeReturn {
  mode: DeviceMode
  setMode: (nextMode: DeviceMode) => void
  isDesktop: boolean
}

export function useDeviceMode(): UseDeviceModeReturn {
  const [mode, setModeState] = useState<DeviceMode>(getStoredDeviceMode)
  const [windowWidth, setWindowWidth] = useState<number>(() =>
    typeof window !== 'undefined' ? window.innerWidth : 1200,
  )

  useEffect(() => {
    function handleResize(): void {
      setWindowWidth(window.innerWidth)
    }

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  function setMode(nextMode: DeviceMode): void {
    setModeState(nextMode)
    setStoredDeviceMode(nextMode)
  }

  const isDesktop = resolveIsDesktop(mode, windowWidth)

  return {
    mode,
    setMode,
    isDesktop,
  }
}
